import { number, string, table } from "@rocicorp/zero";

export const ticketAssignment = table("ticketAssignments")
	.from("ticket_assignments")
	.columns({
		id: string(),
		ticketId: string().from("ticket_id"),
		crewId: string().from("crew_id"),
		createdBy: string().from("created_by"),
		createdAt: number().from("created_at"),
		ranking: number(),
		projectId: string().from("project_id"),
		referenceId: string().from("reference_id"),
		// The plan's organisation, not the crew's: assigning work is the host's right, and
		// the mutators name it rather than leave it to the column default.
		orgId: string().from("org_id"),
	})
	.primaryKey("id");
